import { Box, MenuItem, Select } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { CustomAttributeFieldDataType } from '.'
import { fetchAttributes, fetchRelations } from '../../../services/dtServices'
import { useAppSelector } from '../../../redux/hook'
import { AttributeType } from '../../../constants/constants'

interface CustomAttributeFieldProps {
    data: string
    onChange: any
}

const CustomAttributeField: React.FC<CustomAttributeFieldProps> = (props) => {
    const { data, onChange } = props
    const org = useAppSelector((state) => state.org.org)
    const selectedEntity = useAppSelector(
        (state) => state.dtStudio.selectedEntity,
    )
    const { id: entityId } = selectedEntity
    const orgId = org?.id ? org?.id : ''

    const [value, setValue] = useState<CustomAttributeFieldDataType | null>()

    const [relationsAndEntityTypeList, setRelationsAndEntityTypeList] =
        useState<any>([])
    const [attributeList, setAttributeList] = useState<any>([])

    useEffect(() => {
        if (data) {
            const updatedData = JSON.parse(data)
            if (
                updatedData?.templateId !== value?.templateId &&
                updatedData?.templateId
            ) {
                getAndSetAttributesList(updatedData?.templateId)
            }
            setValue(updatedData)
        }
    }, [data])

    useEffect(() => {
        const getAndSetData = async () => {
            const [relationsData, attributesData] = await Promise.all([
                fetchRelations(entityId, orgId),
                fetchAttributes(orgId, entityId),
            ])

            const relations = relationsData.map(({ displayName, ...rest }) => ({
                ...rest,
                name: displayName,
            }))
            const attributes = attributesData.filter(
                (i) => i.dataType?.toLowerCase() === AttributeType.ENTITY,
            )
            setRelationsAndEntityTypeList([...relations, ...attributes])
        }
        if (entityId && orgId) {
            getAndSetData()
        }
    }, [entityId, orgId])

    const getAndSetAttributesList = async (templateId: string) => {
        const attributesData = await fetchAttributes(orgId, templateId)
        const attributes = attributesData?.filter(
            (i) =>
                !i.metadata?.Hidden &&
                ![
                    AttributeType.CUSTOM_ATTRIBUTE,
                    AttributeType.ENTITY,
                    AttributeType.RULESET,
                ]
                    .map((t) => t.toLowerCase())
                    .includes(i.dataType.toLowerCase()),
        )
        setAttributeList(attributes)
    }

    const handleChangeTemplate = (val: string) => {
        const selectedTemplate = relationsAndEntityTypeList?.find(
            (i: any) => i.id === val,
        )
        const templateId =
            selectedTemplate?.childEntity || selectedTemplate?.range || ''
        const relationName = selectedTemplate?.name

        getAndSetAttributesList(templateId)
        onChange({
            ...value,
            name: val,
            templateId,
            relationName,
            attributeId: '',
        })
    }

    const handleChangeAttribute = (val: string) => {
        const selectedAttribute = attributeList?.find((i: any) => i.id === val)
        const attributeName = selectedAttribute?.name
        onChange({ ...value, attributeId: val, attributeName })
    }

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '15px',
            }}
        >
            <Box sx={{ width: '50%' }}>
                <Select
                    id="select-attribute-field-Type"
                    value={value?.name || ''}
                    onChange={(event: any) => {
                        handleChangeTemplate(event.target.value)
                    }}
                    label=""
                    variant="standard"
                    required={true}
                    sx={{ width: '100%' }}
                >
                    {relationsAndEntityTypeList?.map((s: any) => (
                        <MenuItem key={s.id} value={s.id}>
                            {s.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
            <Box sx={{ width: 'calc(50% - 10px)' }}>
                <Select
                    id="select-attribute-field-Type"
                    value={value?.attributeId || ''}
                    onChange={(event: any) => {
                        handleChangeAttribute(event.target.value)
                    }}
                    label=""
                    variant="standard"
                    required={true}
                    sx={{ width: '100%' }}
                >
                    {attributeList?.map((s: any) => (
                        <MenuItem key={s.id} value={s.id}>
                            {s.name}
                        </MenuItem>
                    ))}
                </Select>
            </Box>
        </Box>
    )
}

export default CustomAttributeField
